import { useTranslate } from '@repo/shared/hooks'
import { Card, Col, Icon, Row, Typography } from '@repo/ui/components'

export const SquareTokenMethodsSection = () => {
  const { t, tRich } = useTranslate()

  return (
    <section id='methods' className='py-5xl sm:py-8xl'>
      <Col className='gap-3xl'>
        <Typography
          variant='h2'
          size='lg'
          weight='bold'
          className='text-center text-neutral-main'
        >
          {t('square_token_methods_title')}
        </Typography>

        <Row className='gap-4xl flex-col md:flex-row items-stretch'>
          {/* Invite Friends Card */}

          <Card className='flex-1 p-3xl bg-neutral-main-80 rounded-lg shadow-md !min-h-full'>
            <Col className='gap-md items-center text-center'>
              <Icon name='GetHand' className='w-20 h-20' size='full' />

              <Typography
                variant='h3'
                size='lg'
                weight='bold'
                className='text-neutral-main'
              >
                {t('square_token_invite_friends_title')}
              </Typography>
              <Typography variant='p' size='md' className='text-neutral-main'>
                {tRich.rich('square_token_invite_friends_desc', {
                  b: (chunks) => <b>{chunks}</b>,
                })}
              </Typography>
            </Col>
          </Card>

          {/* Complete Missions Card */}

          <Card className='flex-1 p-3xl bg-neutral-main-80 rounded-lg shadow-md !min-h-full'>
            <Col className='gap-md items-center text-center'>
              <Icon name='Rocket' className='w-20 h-20' size='full' />
              <Typography
                variant='h3'
                size='lg'
                weight='bold'
                className='text-neutral-main'
              >
                {t('square_token_complete_missions_title')}
              </Typography>
              <Typography variant='p' size='md' className='text-neutral-main'>
                {tRich.rich('square_token_complete_missions_desc', {
                  b: (chunks) => <b>{chunks}</b>,
                })}
              </Typography>
            </Col>
          </Card>
        </Row>
      </Col>
    </section>
  )
}
